import { useQuery } from '@tanstack/react-query';

import { getAcceptLanguage } from '@innovamat/localization';

import type { AppletsBySessionCodeQuery } from '../../generated/types';
import { AppletsBySessionCodeDocument } from '../../generated/types';
import { useGlowApiClient } from '../../graphql-provider';

type Props = {
  courseId: string;
  courseOrder: number;
  language: string;
  region: string;
  sessionCode: string;
  enabled?: boolean;
};

function useUnblockedApplets({
  language,
  region,
  courseId,
  courseOrder,
  sessionCode,
  enabled = true,
}: Props) {
  const { graphqlClient, getAuthToken } = useGlowApiClient();

  const variables = {
    courseId: courseId,
    courseOrder: courseOrder,
    locale: language,
    sessionCode: sessionCode,
    region: region,
  };

  const appletsQuery = useQuery<AppletsBySessionCodeQuery>({
    queryKey: ['Resource', variables, region, language],
    queryFn: () => {
      const headers = {
        'accept-language': getAcceptLanguage(region, language) ?? '*',
        authorization: getAuthToken() ?? '',
      };
      return graphqlClient.request(
        AppletsBySessionCodeDocument,
        variables,
        headers
      );
    },
    enabled:
      !!sessionCode &&
      !!courseId &&
      !!courseOrder &&
      !!region &&
      !!language &&
      enabled,

    retry: false,
  });

  return appletsQuery;
}

export { useUnblockedApplets };
